import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Glyphicon } from "react-bootstrap";
import { languageLevels } from "../../../shared/constants";

/**
 * @desc Languages tab content in candidate profile section
 * @param props
 * @return DOMElement
 */

const Languages = props => {
  return (
    <Col xs={12} md={12} className="candidate-languages tab-body">
      <span className="language">{props.language}</span>
      <span className="star">
        {[...Array(languageLevels[props.skill.toLowerCase()])].map(
          (exp, index) => (
            <Glyphicon key={index} glyph="star" />
          )
        )}
        {[...Array(4 - languageLevels[props.skill.toLowerCase()])].map(
          (x, i) => (
            <Glyphicon key={"star" + i} glyph="star-empty" />
          )
        )}
      </span>
      <span className="fluency-level">
        {props.skill.replace(/(^| )(\w)/g, s => s.toUpperCase())}
      </span>
    </Col>
  );
};
export default Languages;



// WEBPACK FOOTER //
// ./src/components/Client/Languages/Languages.js